import { IDrillDurationLookup } from '../../interfaces/idrill-duration-lookup';
import { AssetTeam } from '../asset-team';
import { PhaseStepType } from '../phase-step-type';

export class DrillDurationLookupBase {
  DrillDurationLookupId: number;
  MinLateralLengthFeet: number;
  DrillDesignId: number;
  DurationDaysWithSpudderRig: number;
  DurationDaysNoSpudderRig: number;
  AssetTeamId: number;
  PhaseStepTypeId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  PhaseStepType?: PhaseStepType;

  constructor(item?: IDrillDurationLookup) {
    if (item) {

      this.DrillDurationLookupId = item.DrillDurationLookupId;
      this.MinLateralLengthFeet = item.MinLateralLengthFeet;
      this.DrillDesignId = item.DrillDesignId;
      this.DurationDaysWithSpudderRig = item.DurationDaysWithSpudderRig;
      this.DurationDaysNoSpudderRig = item.DurationDaysNoSpudderRig;
      this.AssetTeamId = item.AssetTeamId;
      this.PhaseStepTypeId = item.PhaseStepTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.PhaseStepType = new PhaseStepType(item.PhaseStepType);
    }
  }
}